import { apiAuthClient } from 'api/helpers';

import { PostFormsResponseType, PostFormsRequestType } from '../types';

export const postForms = async (request: PostFormsRequestType) => {
  const url = `/api/v2/forms/${request.pathParams.form}`;

  const response = await apiAuthClient.post<PostFormsResponseType>(
    url,
    request.body,
    { params: { dontRetry: true }, headers: request.headers },
  );

  return response.data;
};
